import React, { Component } from "react";
import styled from "styled-components";
import {
  arrayOf,
  bool,
  func,
  node,
  number,
  oneOfType,
  shape,
  string
} from "prop-types";
import { uncontrollable } from "uncontrollable";

import ToggleItem from "./components/ToggleItem";

const ToggleGroupWrapper = styled.div`
  display: flex;
`;

class ToggleGroup extends Component {
  static propTypes = {
    /* Enables disable state styling */
    isDisabled: bool,
    /* functioned supplied by parent component, will receive value when called. to be used with controlled component */
    onSelectionChange: func,
    /* functioned supplied by parent component, will receive event and tab data when called */
    onClick: func,
    /* array of objects representing the tabs text and value */
    tabItems: arrayOf(
      shape({
        text: oneOfType([string, node]),
        value: oneOfType([bool, number, string]),
        subtext: oneOfType([string, node]),
        disabled: bool
      })
    ),
    /* change theme of individual tabs. ex(theme="tabHover") */
    theme: string,
    /* the value of the tab that should be active by default */
    value: oneOfType([bool, number, string])
  };

  static defaultProps = {
    isDisabled: false,
    onSelectionChange: () => {},
    onClick: () => {},
    value: "",
    tabItems: [],
    theme: ""
  };

  /**
   * Click handler that prevents default behavior of click,
   * sets the active tab, and propagates the event and tab data to onClick prop
   *
   * @public
   */

  handleClick = ({ event, tabData }) => {
    const { onClick, onSelectionChange } = this.props;
    onClick({ event, tabData });
    onSelectionChange(tabData.value);
  };

  isActiveValue = item => {
    const { value } = this.props;

    if (value === item.value && !item.disabled) {
      return true;
    }

    return false;
  };

  renderTabItem = item => {
    const { theme } = this.props;
    return (
      <ToggleItem
        key={item.value}
        active={this.isActiveValue(item)}
        aria-checked={this.isActiveValue(item)}
        isDisabled={this.props.isDisabled}
        item={item}
        onClick={this.handleClick}
        role="radio"
        theme={theme}
      />
    );
  };

  render() {
    const {
      onClick,
      onSelectionChange,
      tabItems,
      ...elementProps
    } = this.props;

    return (
      <div>
        {tabItems.length > 0 && (
          <ToggleGroupWrapper {...elementProps} role="radiogroup">
            {tabItems.map(this.renderTabItem)}
          </ToggleGroupWrapper>
        )}
      </div>
    );
  }
}

ToggleGroup.displayName = "ToggleGroup";

const UncontrolledToggleGroup = uncontrollable(ToggleGroup, {
  value: "onSelectionChange"
});

export default UncontrolledToggleGroup;
